import { createSelector } from "reselect";

import type { DisplayedPriceConfig } from "@app/helpers/price";

import type { SupportedLocale } from "@config/locales";

import { getConfig, getSearch } from "./state-accessors";

export const getDisplayedPriceConfig = createSelector(
  [getConfig, getSearch],
  (config, search): DisplayedPriceConfig => {
    return {
      origin_country: search.origin_city?.country_code2,
      user_country: config.user_country,
      user_region: config.user_region,
      locale: config.locale as SupportedLocale,
      features: config.experiments,
      price_mode: config.price_mode
    };
  }
);
